module.exports = __webpack_public_path__ + "img/jmcLogo.d69c6df3.png";